import React from 'react';
import GetAllServiceBookings from './service-bookings/GetAllServiceBookings';

const Bookings = () => {
  return <GetAllServiceBookings />;
};

export default Bookings;
